import { Tuple } from "@suse-o11y/tuple";

const QUERY_NAMESPACE = Tuple("metrics-drawer");

export { QUERY_NAMESPACE };
